{
  "states": {
    "loading": "Cargando...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Despejado",
    "Clouds": "Nubes",
    "Rain": "Lluvia",
    "Drizzle": "Llovizna",
    "Thunderstorm": "Tormenta",
    "Snow": "Nieve",
    "Mist": "Neblina",
    "Smoke": "Humo",
    "Haze": "Bruma",
    "Dust": "Polvo",
    "Fog": "Niebla",
    "Sand": "Arena",
    "Ash": "Ceniza",
    "Squall": "Chubasco",
    "Tornado": "Tornado"
  },
  "modal": {
    "defaultTitle": "Clima",
    "subtitle": "Condiciones actuales",
    "showFahrenheit_aria": "Mostrar Fahrenheit",
    "showCelsius_aria": "Mostrar Celsius",
    "switchToCelsius_title": "Cambiar a °C",
    "switchToFahrenheit_title": "Cambiar a °F",
    "feelsLike": "Sensación de {{temp}}°{{unit}}",
    "humidityWind": "Humedad {{humidity}}% · Viento {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Ahora",
    "hourlyOffset": "{{hours}}h",
    "hourlyStrip_aria": "Temperatura por hora",
    "hourlyLocked": "El pronóstico por hora es una función Pro.",
    "statsLocked": "Los detalles del clima son una función Pro.",
    "stats": {
      "sunrise": "Amanecer",
      "sunset": "Atardecer",
      "feels": "Sensación",
      "humidity": "Humedad",
      "wind": "Viento",
      "rain": "Lluvia"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "Pronóstico de 5 días",
    "forecastLoading": "Cargando pronóstico…",
    "forecastUnavailable": "Pronóstico no disponible",
    "forecastLocked": "El pronóstico de 5 días es una función Pro.",
    "forecastRow_aria": "Pronóstico de cinco días",
    "proHeadline": "El pronóstico completo es parte de Pro.",
    "proFeatures": "Por horas · Condiciones detalladas · Pronóstico de 5 días."
  }
}
